module.exports = __webpack_public_path__ + "static/media/model-sorento-02.6ec6f43e.jpg";